import type { FaireProductEntity } from "../../entity_types/product";

export const p_cnkq5xfgxm: FaireProductEntity = {
  token: "p_cnkq5xfgxm",
  type: "product",
  name: "Tropical Punch",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/fcf78f2f7536849d93c6971a7361256bb34b1b17ed97c567453976131d9b8c68.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/925b447bb4d9b4c8789e78a48c550e4779416fc5aae96086a5424fb8a5cda5bf.png",
    "https://cdn.faire.com/fastly/aa9f22f343326b3d816965edddb799e91e9b050b7190f359b8473be723e3c86f.png",
    "https://cdn.faire.com/fastly/9eac97d52dae8ef173b76e01602e3ff6410a719f23f8bc579a56aab2d102fd95.png",
    "https://cdn.faire.com/fastly/5662c4bbee717c5d5e3525c7549a039235c70554b6df4ae0585c1042b82602fc.png",
  ],
  priceDollars: 28.99,
  description:
    "Like a vacation for your tastebuds, Tropical Punch perfectly balances pineapple, passion fruit, mandarin, and apple juices for a crisp, juicy and nostalgic flavor reminiscent of your favorite childhood fruit punch.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:13.555Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
